import { parsePhoneNumber } from 'react-phone-number-input'

/**
 * Extracts the country code from a phone number in format +123456789
 * @param phoneNumber - Phone number with + prefix (e.g., "+123456789")
 * @returns The country code with + prefix (e.g., "+1", "+44", "+972")
 */
export function extractCountryCode(phoneNumber: string): string {
  if (!phoneNumber || !phoneNumber.startsWith('+')) {
    return ''
  }

  try {
    const parsed = parsePhoneNumber(phoneNumber)
    return parsed ? `+${parsed.countryCallingCode}` : ''
  } catch {
    return ''
  }
}
